export const setProduct = (state, product) => {
  state.product = product;
};
